import React, { useEffect, useRef, useState } from "react";
import './ButtonDropdown.scss';

type ButtonDropdownPropsType = {
    button: React.ReactNode
    children: React.ReactNode | React.ReactNode[],
    className?: string
    disabled?: boolean | (() => boolean) | (() => Promise<boolean>)
}

const HIDDEN_CLASS_NAME = 'hidden';
type DropdownEvent = React.FocusEvent | React.MouseEvent | React.TouchEvent;

const open = (e: DropdownEvent, dropdownElement: HTMLDivElement | null | undefined, action: 'remove' | 'add' | 'toggle') => {
    e.stopPropagation();
    e.preventDefault();
    if (!dropdownElement) return;
    if (action === 'add') {
        if (dropdownElement.contains(e.target as any)) {
            const sender = e.target as HTMLElement;
            sender.click();
        }
    }

    dropdownElement.classList[action](HIDDEN_CLASS_NAME);

    if (dropdownElement.offsetLeft + dropdownElement.offsetWidth > document.body.clientWidth) {
        dropdownElement.classList.add('left-0');
        dropdownElement.classList.remove('right-0');
    } else {
        dropdownElement.classList.remove('left-0');
        dropdownElement.classList.add('right-0');
    }
}

const ButtonDropdown = (props: ButtonDropdownPropsType) => {
    const dropdownElement = useRef<HTMLDivElement>(null);
    const [isMouseEvent, setIsMouseEvent] = useState(false);

    useEffect(() => {
        document.addEventListener('click', onFocusOut)

        return () => {
            document.removeEventListener('click', onFocusOut)
        }
    }, [])

    const onMouseEnter = async (e: React.MouseEvent | React.TouchEvent) => {
        if((e.nativeEvent as any).sourceCapabilities?.firesTouchEvents) {
            return;
        }

        const disabled = await isDisabled();
        if (!disabled) {
            setIsMouseEvent(true);
            open(e, dropdownElement.current, 'remove');
        }
    }
    const onMouseLeave = (e: React.MouseEvent) => {
        if (isMouseEvent) {
            setIsMouseEvent(false);
            open(e, dropdownElement.current, 'add');
        }
    }

    const onOpen = async (e: DropdownEvent, action: 'remove' | 'add' | 'toggle') => {
        const disabled = await isDisabled();
        if (!disabled) {
            open(e, dropdownElement.current, action);
        }
    }

    function onFocusOut(e: MouseEvent | KeyboardEvent | FocusEvent) {
        if (dropdownElement.current?.contains(e.target as Node)) return;
        dropdownElement.current?.classList.add(HIDDEN_CLASS_NAME);
    }

    async function isDisabled() {
        if (props.disabled === undefined) return false;
        if (typeof props.disabled === 'boolean') return props.disabled;
        if (typeof props.disabled === 'function') {
            const disabled = props.disabled();
            if (typeof disabled == 'boolean') return disabled;
            return await disabled;
        }

        return false;
    }

    return (
        <div
            className={`button-dropdown ${props.className || ''}`}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <button title="button-dropdown" onClick={(e) => onOpen(e, 'toggle')}>
                {props.button}
            </button>
            <div className={`${HIDDEN_CLASS_NAME} button-dropdown_dropdown dropdown-zindex`} ref={dropdownElement}>
                <hr />
                {props.children}
            </div>
        </div>
    );
};
export default ButtonDropdown;
